<template>
  <div class="d-flex align-center">
    <div
      v-if="!$vuetify.breakpoint.mobile"
    >
      <v-btn
        v-if="$can(abilityList().customersCreate, 'all')"
        text
        class="mx-1"
        :to="{ name: 'customers-import', params: { enterpriseId: $route.params.enterpriseId } }"
      >
        <v-icon left>
          mdi-database-import
        </v-icon>
        Import
      </v-btn>
    </div>
    <v-menu
      v-else
      offset-y
    >
      <template #activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          icon
          class="mx-2"
          v-on="on"
        >
          <v-icon>
            mdi-menu-down
          </v-icon>
        </v-btn>
      </template>
      <v-list dense>
        <v-list-item
          v-if="$can(abilityList().customersCreate, 'all')"
          class="pl-5 pr-6"
          :to="{ name: 'customers-import', params: { enterpriseId: $route.params.enterpriseId } }"
        >
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-list-item-icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-database-import</v-icon>
              </v-list-item-icon>
              <v-list-item-content
                v-bind="attrs"
                v-on="on"
              >
                <v-list-item-title>Import</v-list-item-title>
              </v-list-item-content>
            </template>
            <span>Import Customer</span>
          </v-tooltip>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>
<script>
import VH from '@/util/variables'

export default {
  data() {
    return {}
  },
  methods: {
    abilityList() {
      return VH.abilityList()
    },
  },
}
</script>